import React from "react";

/**
 * Animated heading with staggered letter reveal effect
 * @param {Object} props
 * @param {string} props.text - The text to animate
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.as - HTML element to render (default: h1)
 * @param {number} props.delayStart - Initial delay in ms before animation starts (default: 0)
 * @param {number} props.letterDelay - Delay between each letter in ms (default: 50)
 */
const AnimatedHeading = ({
  text,
  className = "",
  as: Tag = "h1",
  delayStart = 0,
  letterDelay = 50,
}) => {
  const letters = text.split("");

  return (
    <Tag className={`inline-block ${className}`}>
      {letters.map((letter, index) => (
        <span
          key={index}
          className="inline-block opacity-0 animate-letter-reveal"
          style={{
            animationDelay: `${delayStart + index * letterDelay}ms`,
            animationFillMode: "forwards",
          }}
        >
          {letter === " " ? "\u00A0" : letter}
        </span>
      ))}
    </Tag>
  );
};

export default AnimatedHeading;
